module.exports = __webpack_public_path__ + "img/altitude-resort-7.c785f5e0.jpg";